/**
 * Archivo: assets/recargo-login-enforcer.js
 * Propósito: Forzar login si el usuario necesita recargo de equivalencia
 */

(function() {
  'use strict';
  
  const DEBUG_MODE = true; // Cambiar a false en producción
  
  function debugLog(message, data) {
    if (DEBUG_MODE) {
      if (data !== undefined) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  }
  
  // Esperar a que ShopifyRecargo esté disponible
  if (typeof window.ShopifyRecargo === 'undefined') {
    console.error('recargo-detector.js debe cargarse antes que recargo-login-enforcer.js');
    return;
  }
  
  const { needsRecargo, isLoggedIn } = window.ShopifyRecargo;
  
  debugLog('Estado actual:', { needsRecargo, isLoggedIn });
  
  // Solo actuar si necesita recargo Y NO está logueado
  if (needsRecargo && !isLoggedIn) {
    debugLog('⚠️ Usuario necesita recargo pero no está logueado - Activando modal');
    showLoginModal();
    blockAddToCartButtons();
    blockCheckoutButtons();
  } else {
    debugLog('✓ Usuario no requiere intervención');
  }
  
  /**
   * Muestra el modal de login obligatorio
   */
  function showLoginModal() {
    // Evitar crear múltiples modales
    if (document.getElementById('recargo-login-modal')) {
      debugLog('Modal ya existe, no se crea duplicado');
      return;
    }
    
    const modal = document.createElement('div');
    modal.id = 'recargo-login-modal';
    modal.className = 'recargo-modal-overlay';
    
    const currentPath = window.location.pathname;
    const returnUrl = encodeURIComponent(currentPath);
    
    modal.innerHTML = `
      <div class="recargo-modal-content">
        <div class="recargo-modal-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <h3 class="recargo-modal-title">Inicio de sesión requerido</h3>
        <p class="recargo-modal-text">
          Para aplicar correctamente el <strong>recargo de equivalencia</strong> 
          en tu pedido, necesitas iniciar sesión con tu cuenta.
        </p>
        <p class="recargo-modal-subtext">
          Este recargo se aplica automáticamente según la normativa fiscal.
        </p>
        <a href="/account/login?return_url=${returnUrl}" 
           class="button button--outline button--regular button--loader">
          Iniciar sesión
        </a>
        <button class="recargo-modal-close" onclick="this.closest('.recargo-modal-overlay').style.display='none'">
          Continuar navegando sin comprar
        </button>
      </div>
    `;
    
    document.body.appendChild(modal);
    debugLog('✓ Modal de login creado');
    
    // Prevenir scroll del body cuando el modal está abierto
    document.body.style.overflow = 'hidden';
  }
  
  /**
   * Bloquea los botones de añadir al carrito
   */
  function blockAddToCartButtons() {
    // Selectores comunes en themes de Shopify
    const selectors = [
      'button[name="add"]',
      '.product-form__submit',
      '[data-action="add-to-cart"]',
      '.btn--add-to-cart',
      'button[type="submit"][name="add"]',
      '.product-form button[type="submit"]',
      '[data-add-to-cart]'
    ];
    
    const buttons = document.querySelectorAll(selectors.join(', '));
    
    debugLog(`Bloqueando ${buttons.length} botones de añadir al carrito`);
    
    buttons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.setAttribute('title', 'Debes iniciar sesión para comprar');
      
      // Prevenir clicks
      button.addEventListener('click', preventAction, true);
      button.addEventListener('submit', preventAction, true);
    });
  }
  
  /**
   * Bloquea los botones y enlaces de checkout
   */
  function blockCheckoutButtons() {
    // Selectores para checkout
    const selectors = [
      'button[name="checkout"]',
      '.cart__checkout',
      '.cart__checkout-button',
      '[href*="/checkout"]',
      'button[type="submit"][name="checkout"]',
      '[data-checkout-button]',
      'a[href="/checkout"]',
      '.button--checkout'
    ];
    
    const elements = document.querySelectorAll(selectors.join(', '));
    
    debugLog(`Bloqueando ${elements.length} elementos de checkout`);
    
    elements.forEach(element => {
      // Si es un enlace
      if (element.tagName === 'A') {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          showLoginModal();
        }, true);
        
        element.style.opacity = '0.5';
        element.style.cursor = 'not-allowed';
      } 
      // Si es un botón
      else {
        element.disabled = true;
        element.style.opacity = '0.5';
        element.style.cursor = 'not-allowed';
        
        element.addEventListener('click', preventAction, true);
        element.addEventListener('submit', preventAction, true);
      }
    });
  }
  
  /**
   * Previene la acción y muestra el modal
   */
  function preventAction(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showLoginModal();
    return false;
  }
  
  /**
   * Observer para detectar nuevos botones añadidos dinámicamente
   * (útil para themes con Ajax Cart o infinite scroll)
   */
  if (typeof window.MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      if (needsRecargo && !isLoggedIn) {
        blockAddToCartButtons();
        blockCheckoutButtons();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    debugLog('✓ Observer activado para nuevos elementos');
  }
  
})();